import { UPDATE_VENDOR_PROFILE } from './updateVendorProfile';

export const portalManagementApi = {
  updateVendorProfile: UPDATE_VENDOR_PROFILE,
};
